import { parseBoolean, parseString } from "@de-xima/xima-common-js-lang";

export function isFormThemeRootVolumeEntry(file: elFinder.ElFinderFile | undefined): boolean {
  return parseBoolean(file?.isroot) && parseString(file?.volumeid).startsWith("l");
}
